import { useState, useRef, useLayoutEffect, useCallback } from "react";
import { Typography, IconButton, Box } from "@mui/material";

const ReadMoreText = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [lineHeight, setLineHeight] = useState(0);
    const textRef = useRef(null);

    // Function to calculate line height and check overflow
    const checkOverflow = useCallback(() => {
        if (textRef.current) {
            const computedStyle = getComputedStyle(textRef.current);
            const calculatedLineHeight = parseInt(computedStyle.lineHeight, 8);
            const maxVisibleHeight = calculatedLineHeight * 4;
            setLineHeight(calculatedLineHeight);
            setIsOverflowing(textRef.current.scrollHeight > maxVisibleHeight);
        }
    }, []);

    // Check overflow when text changes
    useLayoutEffect(() => {
        checkOverflow();
    }, [text, checkOverflow]);

    return (
        <Box sx={{ textAlign: "end", minHeight: lineHeight * 5 || "unset" }}>
            <Box
                sx={{
                    minHeight: lineHeight * 5, // Keeps space for 5 lines
                    maxHeight: isExpanded ? "none" : lineHeight * 4, // Limits text to 4 lines
                    overflow: "hidden",
                    WebkitLineClamp: isExpanded ? "unset" : 4,
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    textOverflow: "ellipsis",
                }}
            >
                <Typography
                    ref={textRef}
                    variant="body2"
                    
                    fontWeight={400}
                    color="#4A4A4A"
                    dangerouslySetInnerHTML={{ __html: text }}

                />
            </Box>

            {isOverflowing ? (
                <IconButton onClick={() => setIsExpanded(!isExpanded)} sx={{ padding: 0 }}>
                    <Typography variant="body2" fontWeight={500} color="red">
                        {isExpanded ? "Read Less" : "Read More"}
                    </Typography>
                </IconButton>
            ) : (
                // If text does not overflow, still reserve space for 5 lines
                <Box sx={{ height: lineHeight }} />
            )}
        </Box>
    );
};

export default ReadMoreText;
